import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";
Vue.use(Router)
import defineAbilitiesFor from './config/abilities'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      meta: {
        rule: 'admin',
      },
      children: [
        {
          path: '/campaigns/add-more-field',
          name: 'add-more-field',
          component: () => import('@/views/apps/campaigns/more-fields/AddMoreFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/edit-more-field/:campaignId',
          name: 'edit-more-fieldedit-more-field',
          component: () => import('@/views/apps/campaigns/more-fields/EditMoreFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/core-field/add',
          name: 'add-core-field',
          component: () => import('@/views/apps/fields/core-fields/AddFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'core-fields',
            action: 'create'
          }
        },
        {
          path: '/fields/core-field/edit/:fieldId',
          name: 'core-field-edit',
          component: () => import('@/views/apps/fields/core-fields/EditFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'core-fields',
            action: 'update'
          },
        },
        {
          path: '/fields/core-fields',
          name: 'core-fields',
          component: () => import('@/views/apps/fields/core-fields/ListFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'core-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/core-field/:fieldId',
          name: 'core-fields-view',
          component: () => import('@/views/apps/fields/core-fields/ViewFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'core-fields',
            action: 'read'
          }
        },
        {
          path: '/manage_client_default/client_opportunities/:campaignId',
          name: 'manage-client-default-opportunities',
          component: () => import('@/views/apps/campaigns/client-dashboard/ClientDefaultOpportunities.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/client_opportunities/:campaignId',
          name: 'client-opportunities',
          component: () => import('@/views/apps/campaigns/client-dashboard/ClientOpportunities.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/sales_developer_opportunities/:campaignId',
          name: 'sales-developer-opportunities',
          component: () => import('@/views/apps/dashboards/SalesDeveloperOpportunities.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/vertical/add',
          name: 'add-verticals',
          component: () => import('@/views/apps/verticals/VerticalAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'vertical',
            action: 'create'
          }
        },
        {
          path: '/verticals',
          name: 'verticals',
          component: () => import('@/views/apps/verticals/VerticalList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'vertical',
            action: 'read'
          }
        },
        {
          path: '/vertical/:verticalId',
          name: 'verticals-view',
          component: () => import('@/views/apps/verticals/VerticalView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'vertical',
            action: 'read'
          },
        },
        {
          path: '/vertical/edit/:verticalId',
          name: 'verticals-edit',
          component: () => import('@/views/apps/verticals/VerticalEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'vertical',
            action: 'update'
          },
        },
        {
          path: '/campaign/send_opportunity_alerts',
          name: 'send-opportunity-alerts',
          component: () => import('@/views/apps/campaigns/SendOpportunityAlerts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'send-opportunity-alerts',
            action: 'read'
          },
        },
        {
          path: '/campaign/edit_email_template/:emailTemplateId',
          name: 'edit-email-template',
          component: () => import('@/views/apps/campaigns/email-template/EditEmailTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'email-template',
            action: 'update'
          },
        },
        {
          path: '/campaign/view_email_template/:emailTemplateId',
          name: 'view-email-template',
          component: () => import('@/views/apps/campaigns/email-template/ViewEmailTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'email-template',
            action: 'read'
          },
        },
        {
          path: '/campaign/create_email_template',
          name: 'create-email-template',
          component: () => import('@/views/apps/campaigns/email-template/CreateEmailTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'email-template',
            action: 'create'
          },
        },
        {
          path: '/campaign/manage_email_template',
          name: 'read-email-template',
          component: () => import('@/views/apps/campaigns/email-template/ListEmailTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'email-template',
            action: 'read'
          },
        },
        {
          path: '/campaign/edit_docs_template/:docsTemplateId',
          name: 'edit-docs-template',
          component: () => import('@/views/apps/campaigns/docs-template/EditDocsTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'docs-template',
            action: 'update'
          },
        },
        {
          path: '/campaign/view_docs_template/:docsTemplateId',
          name: 'view-docs-template',
          component: () => import('@/views/apps/campaigns/docs-template/ViewDocsTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'docs-template',
            action: 'read'
          },
        },
        {
          path: '/image_upload',
          name: 'image-upload',
          component: () => import('@/views/ImageUpload.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'image-upload',
            action: 'read'
          },
        },
        {
          path: '/campaign/create_docs_template',
          name: 'create-docs-template',
          component: () => import('@/views/apps/campaigns/docs-template/CreateDocsTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'docs-template',
            action: 'create'
          },
        },
        {
          path: '/campaign/manage_docs_template',
          name: 'read-docs-template',
          component: () => import('@/views/apps/campaigns/docs-template/ListDocsTemplate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'docs-template',
            action: 'read'
          },
        },
        {
          path: '/sales-developer-campaigns/historic/view',
          name: 'historic-sales-developer-campaigns',
          component: () => import('@/views/apps/dashboards/HistoricSalesDeveloperCampaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/sales-developer-campaigns/live/view',
          name: 'live-sales-developer-campaigns',
          component: () => import('@/views/apps/dashboards/LiveSalesDeveloperCampaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/sales-developer-dashboard/view/:campaignId/:campaignName/:forename/:surname/:job_title',
          name: 'sales-developer-dashboard-view',
          component: () => import('@/views/apps/dashboards/SalesDeveloperCampaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/sales-developer-dashboard/view/:campaignId/:campaignName',
          name: 'sales-developer-dashboard',
          component: () => import('@/views/apps/dashboards/SalesDeveloperCampaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/client-dashboard/statistics/:campaignId/:clientUserId',
          name: 'client-statistics',
          component: () => import('@/views/apps/campaigns/client-dashboard/Statistics.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          },
        },
        {
          path: '/client-dashboard/power_bi_embed_dashboard/:campaignId',
          name: 'power-bi-embed-dashboard',
          component: () => import('@/views/apps/campaigns/client-dashboard/EmbedPowerBIDashboard.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,

          },
        },
        {
          path: '/client-campaign-view/live-account-contact/:campaignId/:clientId/:clientUserId',
          name: 'client-campaign-view-select-default-views',
          component: () => import('@/views/apps/views/LiveAccountContactClientAndClientUserView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,

          },
        },
        {
          path: '/client-dashboard/live-account-contact/:campaignId',
          name: 'client-dashboard-select-default-views',
          component: () => import('@/views/apps/campaigns/client-dashboard/LiveAccountContactClientView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,

          },
        },
        {
          path: '/client-dashboard/select_default_fields',
          name: 'client-dashboard-select-default-fields',
          component: () => import('@/views/apps/campaigns/default-views/SelectDefaultFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,

          },
        },
        {
          path: '/client-dashboard/campaign/:campaign_status',
          name: 'client-dashboard-campaign',
          component: () => import('@/views/apps/campaigns/client-dashboard/Campaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/client-dashboard/client_campaign_view/:campaignId',
          name: 'client-campaign-view',
          component: () => import('@/views/apps/campaigns/client-dashboard/ClientCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/client-dashboard/campaignlists',
          name: 'client-dashboard-campaign-lists',
          component: () => import('@/views/apps/campaigns/default-views/CampaignLists.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,

          }
        },
        {
          path: '/client-dashboard/ClientDefaultViewForOpportunities',
          name: 'client-dashboard-client-default-view-for-opportunities',
          component: () => import('@/views/apps/campaigns/default-views/ClientDefaultOpportuntitesCampaignLists.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,

          }
        },
        {
          path: '/campaigns/view-gantt-steps/:campaignId/:clientUserId',
          name: 'client-user-gantt-steps',
          component: () => import('@/views/apps/campaigns/client-dashboard/GanttSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          
          }
        },
        {
          path: '/campaign/edit_grade_category/:gradeCategoryId',
          name: 'campaign-edit-grade-category',
          component: () => import('@/views/apps/campaigns/grade-categories/EditGradeCategory.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'categorize-grades',
            action: 'update'
          },
        },
        {
          path: '/campaign/view_grade_category/:gradeCategoryId',
          name: 'campaign-create-grade-category-view',
          component: () => import('@/views/apps/campaigns/grade-categories/ViewGradeCategory.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'categorize-grades',
            action: 'read'
          },
        },
        {
          path: '/campaign/create_grade_category',
          name: 'campaign-create-grade-category',
          component: () => import('@/views/apps/campaigns/grade-categories/CreateGradeCategory.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'categorize-grades',
            action: 'create'
          },
        },
        {
          path: '/campaign/manage_grade_category',
          name: 'campaign-grade-category',
          component: () => import('@/views/apps/campaigns/grade-categories/ListGradeCategory.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'categorize-grades',
            action: 'read'
          },
        },
        {
          path: '/client_user/default_views/:campaignId',
          name: 'client-user-select-default-views',
          component: () => import('@/views/apps/campaigns/default-views/DefaultViews.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-user-set-default',
            action: 'read'
          },
        },
        {
          path: '/quality_control/review_data/account_detail/:accountId/:campaignId/:campaignName',
          name: 'quality-control-accounts-review-data',
          component: () => import('@/views/apps/quality_control/ReviewQualityControlDetail.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/quality_control/review_data/:campaignId/:campaignName',
          name: 'quality-control-accounts',
          component: () => import('@/views/apps/quality_control/ReviewQualityControl.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/quality_control/review_opportunity_data/:campaignId/:campaignName',
          name: 'opportunity-quality-control-accounts',
          component: () => import('@/views/apps/quality_control/ReviewOpportunityQualityControl.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/quality_control/account_data/:campaignId/:campaignName',
          name: 'quality-control-accounts-account-data',
          component: () => import('@/views/apps/quality_control/QualityControlOnAccountData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/quality_control/contact_data/:campaignId/:campaignName',
          name: 'quality-control-contacts',
          component: () => import('@/views/apps/quality_control/QualityControlOnContactData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/quality_control/campaigns',
          name: 'quality-control-campaigns',
          component: () => import('@/views/apps/dashboards/QualityControlCampaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'dashboard',
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/quality_control/opportunities/campaigns',
          name: 'opportunities-quality-control-campaigns',
          component: () => import('@/views/apps/dashboards/OpportunitiesQualityControlCampaigns.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'dashboard',
            resource: 'quality-control',
            action: 'read'
          }
        },
        {
          path: '/sd_account_status/sd_account_data/:campaignId',
          name: 'sd-account-tags-id',
          component: () => import('@/views/apps/status/AssignStatusOnAccountSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/sd_contact_status/sd_contact_data/:campaignId/:campaignName',
          name: 'sd-contact-tags-data',
          component: () => import('@/views/apps/status/AssignStatusOnContactSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/tag/sd_account_data/:campaignId',
          name: 'sd-account-tags',
          component: () => import('@/views/apps/tag/AssignTagOnAccountSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/tag/sd_contact_data/:campaignId/:campaignName',
          name: 'sd-contact-tags',
          component: () => import('@/views/apps/tag/AssignTagOnContactSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/tag/add',
          name: 'add-tags',
          component: () => import('@/views/apps/tag/TagAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/tags',
          name: 'tags',
          component: () => import('@/views/apps/tag/TagList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/tag/view/:tagId',
          name: 'tags-view',
          component: () => import('@/views/apps/tag/TagView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          },
        },
        {
          path: '/tag/edit/:tagId',
          name: 'tags-edit',
          component: () => import('@/views/apps/tag/TagEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          },
        },
        {
          path: '/grade/clone',
          name: 'grade-steps-list',
          component: () => import('@/views/apps/grades/CloneGrade.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clone-grade',
            action: 'read'
          }
        },
        {
          path: '/grade-step/add',
          name: 'add-grade-steps',
          component: () => import('@/views/apps/grades/GradeStepAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade-steps',
            action: 'create'
          }
        },
        {
          path: '/grade-steps',
          name: 'grade-steps',
          component: () => import('@/views/apps/grades/GradeStepList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade-steps',
            action: 'read'
          }
        },
        {
          path: '/grade-step/view/:gradeStepId',
          name: 'grade-steps-view',
          component: () => import('@/views/apps/grades/GradeStepView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade-steps',
            action: 'read'
          },
        },
        {
          path: '/grade-step/edit/:gradeStepId',
          name: 'grade-steps-edit',
          component: () => import('@/views/apps/grades/GradeStepEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade-steps',
            action: 'update'
          },
        },
        {
          path: '/grade/add',
          name: 'add-grades',
          component: () => import('@/views/apps/grades/GradeAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade',
            action: 'create'
          }
        },
        {
          path: '/grades',
          name: 'grades',
          component: () => import('@/views/apps/grades/GradeList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade',
            action: 'read'
          }
        },
        {
          path: '/grade/view/:gradeId',
          name: 'grades-view',
          component: () => import('@/views/apps/grades/GradeView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade',
            action: 'read'
          },
        },
        {
          path: '/grade/edit/:gradeId',
          name: 'grades-edit',
          component: () => import('@/views/apps/grades/GradeEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'grade',
            action: 'update'
          },
        },
        {
          path: '/audit_trial/action_type_outcome_option/edit/:optionId',
          name: 'audit-trial-edit-action-type',
          component: () => import('@/views/apps/audit-trial/EditActionTypeOutcomeOption.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-action-type',
            action: 'read'
          }
        },
        {
          path: '/audit_trial/action_type_outcome_option',
          name: 'action-type-outcome-option',
          component: () => import('@/views/apps/audit-trial/ActionTypeOutcomeOption.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-action-type',
            action: 'read'
          }
        },
        {
          path: '/audit_trial/select_dial_action',
          name: 'select-dial-action',
          component: () => import('@/views/apps/audit-trial/SelectDialAction.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-dial-action',
            action: 'read'
          }
        },
        {
          path: '/audit_trial/action_type/add',
          name: 'audit-trial-add-action-type',
          component: () => import('@/views/apps/audit-trial/action_type/ActionTypeAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'action-type',
            action: 'create'
          }
        },
        {
          path: '/audit_trial/action_types',
          name: 'audit-trial-read-action-type',
          component: () => import('@/views/apps/audit-trial/action_type/ActionTypeList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'action-type',
            action: 'read'
          }
        },
        {
          path: '/audit_trial/action_type/edit/:action_typeId',
          name: 'audit-trial-edit-action-type-id',
          component: () => import('@/views/apps/audit-trial/action_type/ActionTypeEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'action-type',
            action: 'update'
          }
        },
        {
          path: '/audit_trial/action_type/view/:action_typeId',
          name: 'audit-trial-view-action-type',
          component: () => import('@/views/apps/audit-trial/action_type/ActionTypeView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'action-type',
            action: 'read'
          }
        },
        {
          path: '/audit_trial/outcome/add',
          name: 'audit-trial-add-outcome',
          component: () => import('@/views/apps/audit-trial/outcome/OutcomeAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'outcome',
            action: 'create'
          }
        },
        {
          path: '/audit_trial/outcomes',
          name: 'audit-trial-read-outcome',
          component: () => import('@/views/apps/audit-trial/outcome/OutcomeList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'outcome',
            action: 'read'
          }
        },
        {
          path: '/audit_trial/outcome/edit/:outcomeId',
          name: 'audit-trial-edit-outcome',
          component: () => import('@/views/apps/audit-trial/outcome/OutcomeEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'outcome',
            action: 'update'
          }
        },
        {
          path: '/audit_trial/outcome/view/:outcomeId',
          name: 'audit-trial-view-outcome',
          component: () => import('@/views/apps/audit-trial/outcome/OutcomeView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'outcome',
            action: 'read'
          }
        },
        {
          path: '/campaigns/assign-account-data-to-sd',
          name: 'assign-account-data-to-sd',
          component: () => import('@/views/apps/campaigns/AssignAccountDataToSD.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'assign-data',
            action: 'read'
          }
        },
        {
          path: '/campaigns/assign-contact-data-to-sd',
          name: 'assign-contact-data-to-sd',
          component: () => import('@/views/apps/campaigns/AssignContactDataToSD.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'assign-data',
            action: 'read'
          }
        },
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'dashboard'
          }
        },
        {
          path: '/editor',
          name: 'editor',
          component: () => import('./views/Editor.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'dashboard'
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard-view',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'dashboard'
          }
        },
        {
          path: '/select_column_import_account_to_campaign',
          name: 'select_column_import_account_to_campaign',
          component: () => import('./views/SelectColumnsImportAccountToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/review_other_field_values/:table',
          name: 'review_other_field_values',
          component: () => import('./views/ReviewOtherFieldValues.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/import_account_to_campaign/:table',
          name: 'match_account',
          component: () => import('./views/ImportAccountToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/campaign-account',
          name: 'Campaign Account',
          component: () => import('@/views/CampaignAccount.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/unmatched/:campaignId',
          name: 'unmatched-account',
          component: () => import('@/views/Unmatched.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'unmatched-accounts-contacts',
            action: 'read'
          }
        },
        {
          path: '/contacts/unmatched/:campaignId',
          name: 'unmatched-contact',
          component: () => import('@/views/apps/contacts/UnmatchedContacts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'unmatched-accounts-contacts',
            action: 'read'
          }
        },
        {
          path: '/accounts/unmatched_account_list/',
          name: 'unmatched-account-list',
          component: () => import('@/views/UnmatchedAccountList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'unmatched-accounts-contacts',
            action: 'read'
          }
        },
        {
          path: '/contacts/unmatched_contact_list/',
          name: 'unmatched-contact-list',
          component: () => import('@/views/apps/contacts/UnmatchedContactList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'unmatched-accounts-contacts',
            action: 'read'
          }
        },
        {
          path: '/accounts/matched_account_contact_list/',
          name: 'matched-account-list',
          component: () => import('@/views/AccountContactListOfCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/ml/matched/:campaignId/:table_name',
          name: 'matched-ml-accounts',
          component: () => import('./views/MatchedMlAccounts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/remain_unmatched/:campaignId',
          name: 'remain-unmatched-accounts',
          component: () => import('@/views/Remain_Unmatched.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'unmatched-accounts-contacts',
            action: 'read'
          }
        },
        {
          path: '/contacts/remain_unmatched/:campaignId',
          name: 'remain-unmatched-contacts',
          component: () => import('@/views/apps/contacts/Contacts_Remain_Unmatched.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'unmatched-accounts-contacts',
            action: 'read'
          }
        },
        {
          path: '/accounts/enrichAccountDataToMasterDb/:campaignId',
          name: 'enrich-account-data-to-master-data',
          component: () => import('@/views/enrichAccountDataToMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/compareNewExcelDataToMasterDb/:campaignId',
          name: 'compare-account-data-to-master-data',
          component: () => import('@/views/compareNewExcelDataToAccountMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/contacts/compareNewExcelDataToMasterDb/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/compareNewExcelDataToContactMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/enrichAccountFieldDataToMasterDb/:campaignId',
          name: 'enrich-account-field-data-to-master-data',
          component: () => import('@/views/enrichAccountFieldDataToMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/contacts/enrichContactFieldDataToMasterDb/:campaignId',
          name: 'enrich-contact-field-data-to-master-data',
          component: () => import('@/views/enrichContactFieldDataToMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/optionsAfterImportAccountToCampaign/:campaignId',
          name: 'options-after-import-account-to-campaign',
          component: () => import('@/views/OptionsAfterImportAccountToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/DeduplicateOldAndNewAccountCSVData/:campaignId',
          name: 'deduplicate-old-and-new-account-csv-data',
          component: () => import('@/views/DeduplicateOldAndNewAccountCSVData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/contacts/enrichContactDataToMasterDb/:campaignId',
          name: 'enrich-contact-data-to-master-data',
          component: () => import('@/views/apps/contacts/enrichContactDataToMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/contacts/optionsAfterImportContactToCampaign/:campaignId',
          name: 'options-after-import-contact-to-campaign',
          component: () => import('@/views/apps/contacts/OptionsAfterImportContactToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/contacts/DeduplicateOldAndNewContactCSVData/:campaignId',
          name: 'deduplicate-old-and-new-contact-csv-data',
          component: () => import('@/views/apps/contacts/DeduplicateOldAndNewContactCSVData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/accounts/add',
          name: 'add-accounts',
          component: () => import('@/views/apps/accounts/AddAccounts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'accounts',
            action: 'create'
          }
        },
        {
          path: '/accounts',
          name: 'accounts',
          component: () => import('@/views/apps/accounts/AccountList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'accounts',
            action: 'read'
          }
        },
        {
          path: '/accounts/:accountId',
          name: 'accounts-view',
          component: () => import('@/views/apps/accounts/AccountView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'accounts',
            action: 'read'
          },
        },
        {
          path: '/enhance_account_registration_number',
          name: 'enhance-account-reg-number',
          component: () => import('@/views/apps/accounts/EnhanceAccountRegistrationNumber.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/enhance_account_registration_number/update/:datas',
          name: 'enhance-account-reg-number-update',
          component: () => import('@/views/apps/accounts/EnhanceAccountRegistrationNumberUpdate.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/enhance_account_machine_learning/:table/:selected_fields',
          name: 'enhanceaccountmachinelearning',
          component: () => import('@/views/apps/accounts/EnhanceAccountMachineLearning.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/select_columns_enhance_account_machine_learning',
          name: 'select-columns-enhance-account-machine-learning',
          component: () => import('@/views/apps/accounts/SelectColumnsEnhanceAccountMachineLearning.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/resume_enhance_account_machine_learning',
          name: 'resumenhanceaccountmachinelearning',
          component: () => import('@/views/apps/accounts/ResumeEnhancedAccount.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/enhance_account_machine_learning_remainder/:table/:selected_fields',
          name: 'enhanceaccountmachinelearningRemainder',
          component: () => import('@/views/apps/accounts/EnhanceAccountMachineLearningRemainder.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/enhanced_rejected_accounts/:table/:selected_fields',
          name: 'enhancedRejectedAccounts',
          component: () => import('@/views/apps/accounts/EnhancedRejected.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-accounts-contacts-directly-to-database',
            action: 'read'
          },
        },
        {
          path: '/accounts/edit/:accountId',
          name: 'accounts-edit',
          component: () => import('@/views/apps/accounts/EditAccount.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'accounts',
            action: 'update'
          },
        },
        {
          path: '/clients/add',
          name: 'add-clients',
          component: () => import('@/views/apps/clients/ClientAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'create'
          }
        },
        {
          path: '/clients/addEmail',
          name: 'add-client-email',
          component: () => import('@/views/apps/clients/ClientEmailAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-email',
            action: 'create'
          }
        },
        {
          path: '/clients/emailList',
          name: 'client-email-list',
          component: () => import('@/views/apps/clients/ClientEmailList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-email',
            action: 'read'
          }
        },
        {
          path: '/clients/emailList/view/:clientEmailId',
          name: 'client-email-view',
          component: () => import('@/views/apps/clients/ClientEmailView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-email',
            action: 'read'
          }
        },
        {
          path: '/clients/emailList/edit/:clientEmailId',
          name: 'client-email-edit',
          component: () => import('@/views/apps/clients/ClientEmailEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-email',
            action: 'read'
          }
        },
        {
          path: '/clients',
          name: 'clients-list',
          component: () => import('@/views/apps/clients/ClientList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'read'
          }
        },
        {
          path: '/clients/:clientId',
          name: 'clients-view',
          component: () => import('@/views/apps/clients/ClientView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'read'
          },
        },
        {
          path: '/clients/edit/:clientId',
          name: 'clients-edit',
          component: () => import('@/views/apps/clients/ClientEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'update'
          },
        },
        {
          path: '/contacts/csv_all_matched/:campaignId',
          name: 'csv-matched-contacts',
          component: () => import('@/views/apps/contacts/Contacts_Csv_Matched.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import_contacts',
            action: 'read'
          },
        },
        {
          path: '/select_column_import_contact_to_campaign',
          name: 'select_column_import_contact_to_campaign',
          component: () => import('./views/SelectColumnsImportContactToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        {
          path: '/import_contact_to_campaign/:campaignId',
          name: 'import-contact-to-campaign',
          component: () => import('@/views/apps/contacts/ImportContactToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/contacts/ml/matched/:campaignId/:table_name',
          name: 'matched-ml-contacts',
          component: () => import('@/views/apps/contacts/MatchedMLContact.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/contacts/import_to_master_db',
          name: 'import-contacts',
          component: () => import('@/views/apps/contacts/ImportContactToMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/contacts/unAssocicatedContacts/:campaignId',
          name: 'unassociated-contacts',
          component: () => import('@/views/apps/contacts/UnAssociatedContacts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/matched/:campaignId/:campaignName',
          name: 'matched-accounts-contacts-for-campaign',
          component: () => import('@/views/MatchedAccountContactForCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/enriched_account_contact_for_campaign/:campaignId',
          name: 'enriched-account-contact-for-contact',
          component: () => import('@/views/EnrichedAccountContactForCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/enrich_account_to_campaign/:campaignId',
          name: 'enrich-account-to-campaign',
          component: () => import('@/views/EnrichAccountToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/add_contacts_to_existing_campaign_accounts/:campaignId',
          name: 'add-contacts-to-existing-campaign-accounts',
          component: () => import('@/views/addContactsToExistingCampaignAccounts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/add_new_accounts_contacts_to_campaign/:campaignId',
          name: 'add-new-accounts-contacts-to-campaign',
          component: () => import('@/views/addNewAccountsContactsToCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/select_filter_for_enrich_data/:campaignId',
          name: 'select-filter-for-enrich-data',
          component: () => import('@/views/SelecFiltertForEnrichData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/select_filter_for_enrich_account_data/:campaignId',
          name: 'select-filter-for-enrich-account-data',
          component: () => import('@/views/SelecFiltertForEnrichAccountData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/select_filter_for_enrich_new_account_data/:campaignId',
          name: 'select-filter-for-enrich-new-account-data',
          component: () => import('@/views/SelecFiltertForEnrichNewAccountData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/add_new_account_contacts_with_advanced_criteria/:campaignId',
          name: 'add-new-account-contacts-with-advanced-criteria',
          component: () => import('@/views/AddNewAccountsContactsWithAdvancedCriteria.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/accounts/new_selected_accounts/:campaignId',
          name: 'new-selected_accounts-for-campaign',
          component: () => import('@/views/NewSelectedAccounts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/contacts/matched/:campaignId',
          name: 'matched-contacts',
          component: () => import('@/views/apps/contacts/MatchedContact.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          },
        },
        {
          path: '/contacts/add',
          name: 'add-contacts',
          component: () => import('@/views/apps/contacts/AddContacts.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'contacts',
            action: 'create'
          }
        },
        {
          path: '/contacts/edit/:contact_id/:account_id',
          name: 'edit-contacts',
          component: () => import('@/views/apps/contacts/EditContact.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'contacts',
            action: 'update'
          }
        },
        {
          path: '/contacts',
          name: 'contacts',
          component: () => import('@/views/apps/contacts/ContactList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'contacts',
            action: 'read'
          }
        },
        {
          path: '/contacts/view/:contact_id/:account_id',
          name: 'contacts-view',
          component: () => import('@/views/apps/contacts/ContactView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'contacts',
            action: 'read'
          },
        },
        {
          path: '/elomark-user/add',
          name: 'add-elomark-users',
          component: () => import('@/views/apps/elomark-user/ElomarkUserAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'elomark-users',
            action: 'create'
          }
        },
        {
          path: '/elomark-users',
          name: 'elomark-users',
          component: () => import('@/views/apps/elomark-user/ElomarkUserList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'elomark-users',
            action: 'read'
          }
        },
        {
          path: '/elomark-user/:userId',
          name: 'elomark-users-view',
          component: () => import('@/views/apps/elomark-user/ElomarkUserView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'elomark-users',
            action: 'read'
          },
        },
        {
          path: '/elomark-user/edit/:userId',
          name: 'elomark-users-edit',
          component: () => import('@/views/apps/elomark-user/ElomarkUserEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'elomark-users',
            action: 'update'
          },
        },
        {
          path: '/user/profile/:userId',
          name: 'user-profile',
          component: () => import('@/views/apps/user/UserProfile.vue'),
          meta: {
            rule: 'admin',
            authRequired : true
          },
        },
        {
          path: '/client-user/add',
          name: 'add-client-users',
          component: () => import('@/views/apps/client-user/ClientUserAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-users',
            action: 'create'
          }
        },
        {
          path: '/client-users',
          name: 'client-users',
          component: () => import('@/views/apps/client-user/ClientUserList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-users',
            action: 'read'
          }
        },
        {
          path: '/client-user/:userId',
          name: 'client-users-view',
          component: () => import('@/views/apps/client-user/ClientUserView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-users',
            action: 'read'
          },
        },
        {
          path: '/client-user/edit/:userId',
          name: 'client-users-edit',
          component: () => import('@/views/apps/client-user/ClientUserEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-users',
            action: 'update'
          },
        },
        {
          path: '/client/add',
          name: 'add-client',
          component: () => import('@/views/apps/clients/ClientAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'create'
          }
        },
        {
          path: '/clients',
          name: 'clients',
          component: () => import('@/views/apps/clients/ClientList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'read'
          }
        },
        {
          path: '/client/:userId',
          name: 'client-view',
          component: () => import('@/views/apps/clients/ClientView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'read'
          },
        },
        {
          path: '/client/edit/:userId',
          name: 'client-edit',
          component: () => import('@/views/apps/clients/ClientEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'clients',
            action: 'update'
          },
        },
        {
          path: '/role/add',
          name: 'add-roles',
          component: () => import('@/views/apps/roles/RolesAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'roles',
            action: 'create'
          }
        },
        {
          path: '/roles',
          name: 'roles',
          component: () => import('@/views/apps/roles/RolesList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'roles',
            action: 'read'
          }
        },
        {
          path: '/role/:roleId',
          name: 'roles-view',
          component: () => import('@/views/apps/roles/RolesView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'roles',
            action: 'read'
          },
        },
        {
          path: '/role/edit/:roleId',
          name: 'roles-view-edit',
          component: () => import('@/views/apps/roles/RolesEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'roles',
            action: 'update'
          },
        },
        //  {
        //   path: '/batch_client/add',
        //   name: 'add-batch_clients',
        //   component: () => import('@/views/apps/batch_clients/BatchClientsAdd.vue'),
        //   meta: {
        //     rule: 'admin',
        //     authRequired : true,
        //     resource: 'roles',
        //     action: 'create'
        //   }
        // },
        // {
        //   path: '/batch_clients',
        //   name: 'batch_clients',
        //   component: () => import('@/views/apps/batch_clients/BatchClientsList.vue'),
        //   meta: {
        //     rule: 'admin',
        //     authRequired : true,
        //     resource: 'roles',
        //     action: 'read'
        //   }
        // },
        // {
        //   path: '/batch_client/:batch_clientId',
        //   name: 'batch_clients-view',
        //   component: () => import('@/views/apps/batch_clients/BatchClientsView.vue'),
        //   meta: {
        //     rule: 'admin',
        //     authRequired : true,
        //     resource: 'roles',
        //     action: 'read'
        //   },
        // },
        // {
        //   path: '/batch_client/edit/:batch_clientId',
        //   name: 'batch_clients-view-edit',
        //   component: () => import('@/views/apps/batch_clients/BatchClientsEdit.vue'),
        //   meta: {
        //     rule: 'admin',
        //     authRequired : true,
        //     resource: 'roles',
        //     action: 'update'
        //   },
        // },
        {
          path: '/roles/role-permission',
          name: 'roles-permission',
          component: () => import('@/views/apps/roles/RolePermission.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'roles',
            action: 'read'
          }
        },
        {
          path: '/campaigns/steps-dependency/:campaignId',
          name: 'steps-dependency',
          component: () => import('@/views/apps/campaigns/StepsDependency.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/steps-start-end-assign/:campaignId',
          name: 'steps-start-end-assign',
          component: () => import('@/views/apps/campaigns/StepsStartEndAssign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/initial-select-dependency/:campaignId',
          name: 'initial-select-dependency',
          component: () => import('@/views/apps/campaigns/IntialSelectDependency.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },
        // {
        //   path: '/campaigns/arranged-steps/:campaignId',
        //   name: 'arranged-steps',
        //   component: () => import('@/views/apps/campaigns/ArrangedSteps.vue'),
        //   meta: {
        //     rule: 'admin',
        //     authRequired : true,
        //     resource: 'roles',
        //     action: 'create'
        //   }
        // },
        {
          path: '/campaigns/view-gantt-steps',
          name: 'view-gantt-steps',
          component: () => import('@/views/apps/campaigns/ViewGanttSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },

        {
          path: '/campaigns/edit-campaign-step/:campaignId',
          name: 'edit-campaign-step',
          component: () => import('@/views/apps/campaigns/EditCampaignSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/choose-campaign-steps',
          name: 'choose-campaign-steps',
          component: () => import('@/views/apps/campaigns/ChooseCampaignSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/manage-campaign-steps',
          name: 'manage-campaign-steps',
          component: () => import('@/views/apps/campaigns/ManageCampaignSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/master-step/add',
          name: 'add-master-step',
          component: () => import('@/views/apps/campaigns/master-steps/AddSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-steps',
            action: 'create'
          }
        },
        {
          path: '/campaigns/master-step/edit/:stepId',
          name: 'master-step-edit',
          component: () => import('@/views/apps/campaigns/master-steps/EditSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-steps',
            action: 'update'
          },
        },
        {
          path: '/campaigns/master-steps',
          name: 'master-steps',
          component: () => import('@/views/apps/campaigns/master-steps/ListSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/master-step/:stepId',
          name: 'master-steps-view',
          component: () => import('@/views/apps/campaigns/master-steps/ViewSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-steps',
            action: 'read'
          },
        },
        {
          path: '/campaigns/client-campaign-step/add',
          name: 'add-client-campaign-step',
          component: () => import('@/views/apps/campaigns/client-campaign-steps/AddSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-steps',
            action: 'create'
          }
        },
        {
          path: '/campaigns/client-campaign-steps',
          name: 'client-campaign-steps',
          component: () => import('@/views/apps/campaigns/client-campaign-steps/ListSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-steps',
            action: 'read'
          }
        },
        {
          path: '/campaigns/client-campaign-step/:stepId',
          name: 'client-campaign-steps-view',
          component: () => import('@/views/apps/campaigns/client-campaign-steps/ViewSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-steps',
            action: 'read'
          },
        },
        {
          path: '/campaigns/client-campaign-step/edit/:stepId',
          name: 'client-campaign-steps-edit',
          component: () => import('@/views/apps/campaigns/client-campaign-steps/EditSteps.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-steps',
            action: 'update'
          },
        },
        {
          path: '/usertype/add',
          name: 'add-usertypes',
          component: () => import('@/views/apps/usertypes/UserTypeAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'user-types',
            action: 'create'
          }
        },
        {
          path: '/usertypes',
          name: 'usertypes',
          component: () => import('@/views/apps/usertypes/UserTypeList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'user-types',
            action: 'read'
          }
        },
        {
          path: '/usertype/:usertypeId',
          name: 'usertypes-view',
          component: () => import('@/views/apps/usertypes/UserTypeView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'user-types',
            action: 'read'
          },
        },
        {
          path: '/usertype/edit/:usertypeId',
          name: 'usertypes-edit',
          component: () => import('@/views/apps/usertypes/UserTypeEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'user-types',
            action: 'update'
          },
        },
        {
          path: '/campaign/approveWorkingHours',
          name: 'approve-working-hours',
          component: () => import('@/views/apps/campaigns/ApproveSubmittedHours.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'submit-hours',
            action: 'read'
          }
      },
        {
          path: '/campaign/add',
          name: 'add-campaign',
          component: () => import('@/views/apps/campaigns/CampaignAdd.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaigns',
            action: 'create'
          }
        },
        {
          path: '/campaigns/sd_campaign_view_settings',
          name: 'sd-campaign-view-settings',
          component: () => import('@/views/apps/campaigns/SDCampiagnViewSettings.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/campaigns/submitHours',
          name: 'campaign-submit-hours',
          component: () => import('@/views/apps/campaigns/SubmitHours.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/campaigns/viewSubmitHours',
          name: 'campaign-view-submit-hours',
          component: () => import('@/views/apps/campaigns/SubmitHoursView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/campaigns/viewManagerSubmitHours',
          name: 'campaign-view-manager-submit-hours',
          component: () => import('@/views/apps/campaigns/ManagerSubmitHoursView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'submit-hours',
            action: 'read'
          }
        },
        {
          path: '/campaign/viewSubmitHour/:submitId',
          name: 'campaign-view-submit-hour-submit',
          component: () => import('@/views/apps/campaigns/ViewSingleSubmitHour.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          },
        },
        {
          path: '/campaigns',
          name: 'campaigns',
          component: () => import('@/views/apps/campaigns/CampaignList.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaigns',
            action: 'read'
          }
        },
        {
          path: '/campaign/:campaignId',
          name: 'campaign-view',
          component: () => import('@/views/apps/campaigns/CampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaigns',
            action: 'read'
          },
        },
        {
          path: '/campaign/edit/:campaignId',
          name: 'campaign-view-edit',
          component: () => import('@/views/apps/campaigns/CampaignEdit.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaigns',
            action: 'update'
          },
        },
        {
          path: '/calendar',
          name: 'view-calendar',
          component: () => import('@/views/apps/calendars/ViewCalendar.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'calendar',
            action: 'read'
          }
        },
        {
          path: '/calendar/usersCalendar',
          name: 'view-users-calendar',
          component: () => import('@/views/apps/calendars/UsersCalendar.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'calendar',
            action: 'read'
          }
        },
        {
          path: '/calendar/defaultSettings',
          name:'calendar-default-settings',
          component: () => import('@/views/apps/calendars/DefaultSettings.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'calendar',
            action: 'read'
          }
        },
        {
          path: '/calendar/scheduleAvailability',
          name:'calendar-schedule-availability',
          component: () => import('@/views/apps/calendars/ScheduleAvailabilty.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'calendar',
            action: 'read'
          }
        },
        {
          path: '/campaigns/add-field-values',
          name: 'add-field-values',
          component: () => import('@/views/apps/campaigns/field-values/AddFieldValues.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'field-values',
            action: 'read'
          }
        },
        {
          path: '/campaigns/populate-sd-data',
          name: 'populate-sd-data',
          component: () => import('@/views/apps/campaigns/field-values/PopulateSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'populate-data',
            action: 'read'
          }
        },
        {
          path: '/campaigns/populate-additional-data',
          name: 'populate-additional-data',
          component: () => import('@/views/apps/campaigns/field-values/PopulateAdditionalSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'populate-data',
            action: 'read'
          }
        },
        {
          path: '/campaigns/refresh-sd-data',
          name: 'refresh-sd-data',
          component: () => import('@/views/apps/campaigns/field-values/RefreshSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'populate-data',
            action: 'read'
          }
        },
        {
          path: '/campaigns/validate-sd-and-master-db-data/:campaignId',
          name: 'validate-sd-and-master-db-data',
          component: () => import('@/views/ValidateAccountDataToMasterDb.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'populate-data',
            action: 'read'
          }
        },
        // {
        //   path: '/campaigns/edit-core-field/:campaignId',
        //   name: 'add-master-field',
        //   component: () => import('@/views/apps/campaigns/core-fields/EditCoreFields.vue'),
        //   meta: {
        //     rule: 'admin',
        //     authRequired : true,
        //     resource: 'master-step',
        //     action: 'create'
        //   }
        // },
        {
          path: '/campaigns/add-core-field',
          name: 'add-core-field',
          component: () => import('@/views/apps/campaigns/more-fields/AddCoreFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/add-more-field',
          name: 'add-more-field',
          component: () => import('@/views/apps/campaigns/more-fields/AddMoreFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/list-more-field',
          name: 'list-more-field',
          component: () => import('@/views/apps/campaigns/more-fields/ListMoreFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/edit-more-field/:campaignId',
          name: 'edit-more-fieldedit-more-field',
          component: () => import('@/views/apps/campaigns/more-fields/EditMoreFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'select-campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/add-more-fields-for-cascade',
          name: 'add-more-fields-for-cascade',
          component: () => import('@/views/apps/campaigns/cascading-fields/SelectCascadingFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'cascading-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/list-cascade-fields',
          name: 'list-cascade-fields',
          component: () => import('@/views/apps/campaigns/cascading-fields/ListCascadingFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'cascading-fields',
            action: 'read'
          }
        },
        {
          path: '/campaigns/edit-fields-for-cascade/:cascadeFieldId',
          name: 'edit-fields-for-cascade',
          component: () => import('@/views/apps/campaigns/cascading-fields/EditCascadingFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'cascading-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/master-field/add',
          name: 'add-master-field',
          component: () => import('@/views/apps/fields/master-fields/AddFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-fields',
            action: 'create'
          }
        },
        {
          path: '/fields/master-field/edit/:fieldId',
          name: 'master-field-edit',
          component: () => import('@/views/apps/fields/master-fields/EditFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-fields',
            action: 'update'
          },
        },
        {
          path: '/fields/master-fields',
          name: 'master-fields',
          component: () => import('@/views/apps/fields/master-fields/ListFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/master-field/:fieldId',
          name: 'master-fields-view',
          component: () => import('@/views/apps/fields/master-fields/ViewFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'master-fields',
            action: 'read'
          },
        },
        {
          path: '/fields/client-field/add',
          name: 'add-client-field',
          component: () => import('@/views/apps/fields/client-fields/AddFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-fields',
            action: 'create'
          }
        },
        {
          path: '/fields/client-field/edit/:fieldId',
          name: 'client-field-edit',
          component: () => import('@/views/apps/fields/client-fields/EditFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-fields',
            action: 'update'
          },
        },
        {
          path: '/fields/client-fields',
          name: 'client-fields',
          component: () => import('@/views/apps/fields/client-fields/ListFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/client-field/:fieldId',
          name: 'client-fields-view',
          component: () => import('@/views/apps/fields/client-fields/ViewFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-fields',
            action: 'read'
          },
        },
        {
          path: '/fields/campaign-field/add',
          name: 'add-campaign-field',
          component: () => import('@/views/apps/fields/campaign-fields/AddFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-fields',
            action: 'create'
          }
        },
        {
          path: '/fields/campaign-field/edit/:fieldId',
          name: 'campaign-field-edit',
          component: () => import('@/views/apps/fields/campaign-fields/EditFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-fields',
            action: 'update'
          },
        },
        {
          path: '/fields/campaign-fields',
          name: 'campaign-fields',
          component: () => import('@/views/apps/fields/campaign-fields/ListFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/campaign-field/:fieldId',
          name: 'campaign-fields-view',
          component: () => import('@/views/apps/fields/campaign-fields/ViewFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'campaign-fields',
            action: 'read'
          },
        },
        {
          path: '/fields/opportunity-field/add',
          name: 'add-opportunity-field',
          component: () => import('@/views/apps/fields/opportunity-fields/AddFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'opportunity-fields',
            action: 'create'
          }
        },
        {
          path: '/fields/opportunity-field/edit/:fieldId',
          name: 'opportunity-field-edit',
          component: () => import('@/views/apps/fields/opportunity-fields/EditFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'opportunity-fields',
            action: 'update'
          },
        },
        {
          path: '/fields/opportunity-fields',
          name: 'opportunity-fields',
          component: () => import('@/views/apps/fields/opportunity-fields/ListFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'opportunity-fields',
            action: 'read'
          }
        },
        {
          path: '/fields/opportunity-field/:fieldId',
          name: 'opportunity-fields-view',
          component: () => import('@/views/apps/fields/opportunity-fields/ViewFields.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'opportunity-fields',
            action: 'read'
          },
        },
        {
          path: '/campaigns/purchase-order/add',
          name: 'add-purchase-order',
          component: () => import('@/views/apps/campaigns/purchase-orders/AddPurchaseOrder.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'purchase-order',
            action: 'create'
          }
        },
        {
          path: '/campaigns/purchase-order/edit/:purchaseOrderId',
          name: 'purchase-order-edit',
          component: () => import('@/views/apps/campaigns/purchase-orders/EditPurchaseOrder.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'purchase-order',
            action: 'update'
          },
        },
        {
          path: '/campaigns/purchase-orders',
          name: 'purchase-orders',
          component: () => import('@/views/apps/campaigns/purchase-orders/ListPurchaseOrder.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'purchase-order',
            action: 'read'
          }
        },
        {
          path: '/campaigns/purchase-order/:purchaseOrderId',
          name: 'purchase-orders-view',
          component: () => import('@/views/apps/campaigns/purchase-orders/ViewPurchaseOrder.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'purchase-order',
            action: 'read'
          },
        },
        {
          path: '/views/client_view',
          name: 'views-client-view',
          component: () => import('@/views/apps/views/ClientSearchView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/client_view/search/:client_id/:client_user_id/:client_user_full_name',
          name: 'views-client-view',
          component: () => import('@/views/apps/views/ClientSelectedSearch.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/sd_view',
          name: 'views-sd-view',
          component: () => import('@/views/apps/views/SDSearchView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/:campaignId/:campaignName',
          name: 'views-sd-campaign-view',
          component: () => import('@/views/apps/views/AllSDCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/:campaignId/:campaignName/:forename/:surname/:job_title',
          name: 'sales-developer-dashboard-view',
          component: () => import('@/views/apps/views/AllSDCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/views/all_sd_campaign_view/filter_grade_changed/:campaignId/:campaignName',
          name: 'views-sd-campaign-view-filter-grade-changed',
          component: () => import('@/views/apps/views/AllSDCampaignFilterGradeChangeCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/filter_audit_trial_changed/:campaignId/:campaignName',
          name: 'views-sd-campaign-view-filter-audit-trial-changed',
          component: () => import('@/views/apps/views/AllSDCampaignFilterAuditTrialChangeCampaign.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/sd_campaign_view/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name',
          name: 'views-sd-campaign-view',
          component: () => import('@/views/apps/views/SDCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/sd_campaign_view/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name/:forename/:surname/:job_title',
          name: 'sales-developer-dashboard-view',
          component: () => import('@/views/apps/views/SDCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
          }
        },
        {
          path: '/views/sd_campaign_view/assign_account_status/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name',
          name: 'views-sd-campaign-view-account-status',
          component: () => import('@/views/apps/views/AdminViewAssignStatusOnAccountSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/assign_account_status/:campaignId/:campaignName',
          name: 'views-sd-campaign-view-account-status',
          component: () => import('@/views/apps/views/AllAdminViewAssignStatusOnAccountSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/sd_campaign_view/assign_contact_status/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name',
          name: 'views-sd-campaign-view-contact-status',
          component: () => import('@/views/apps/views/AdminViewAssignStatusOnContactSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/assign_contact_status/:campaignId/:campaignName',
          name: 'views-sd-campaign-view-contact-status',
          component: () => import('@/views/apps/views/AllAdminViewAssignStatusOnContactSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/sd_campaign_view/assign_contact_tag/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name',
          name: 'views-sd-campaign-view-contact-tag',
          component: () => import('@/views/apps/views/AdminViewAssignTagOnContactSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/assign_contact_tag/:campaignId/:campaignName',
          name: 'views-sd-campaign-view-contact-tag',
          component: () => import('@/views/apps/views/AllAdminViewAssignTagOnContactSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/all_sd_campaign_view/assign_account_tag/:campaignId/:campaignName',
          name: 'views-sd-campaign-view-account-tag',
          component: () => import('@/views/apps/views/AllAdminViewAssignTagOnAccountSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/sd_campaign_view/assign_account_tag/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name',
          name: 'views-sd-campaign-view-account-tag',
          component: () => import('@/views/apps/views/AdminViewAssignTagOnAccountSDData.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
         {
          path: '/views/sd_campaign_view/sales_developer_opportunities/:campaignId/:campaignName/:sd_user_id/:sd_user_full_name',
          name: 'views-sd-campaign-view-opportunities',
          component: () => import('@/views/apps/views/AdminViewSalesDeveloperOpportunities.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'sales-developer-campaign-views',
            action: 'read'
          },
        },
        {
          path: '/views/client_campaign_view/:campaign_status/:client_id/:client_user_id/:client_user_full_name',
          name: 'views-client-and-client-user-campaign-view',
          component: () => import('@/views/apps/views/ClientAndClientUserCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-campaign-views',
            action: 'read'
          }
        },
        {
          path: '/views/client_campaign_view/:campaign_status/:client_id',
          name: 'views-client-campaign-view',
          component: () => import('@/views/apps/views/ClientCampaignView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'client-campaign-views',
            action: 'read'
          }
        },
        {
          path: '/campaigns/validateSDAccountDataWithMasterDBView/:campaignId',
          name: 'compare-account-data-to-master-data',
          component: () => import('@/views/ValidateSDAccountDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/campaigns/validateClientViewAccountDataWithMasterDBView/:campaignId',
          name: 'compare-account-data-to-master-data',
          component: () => import('@/views/ValidateClientViewAccountDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
           {
          path: '/campaigns/validateSDContactDataWithMasterDBView/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/ValidateSDContactDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/campaigns/validateClientViewContactDataWithMasterDBView/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/ValidateClientViewContactDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/contacts/validateSDContactDataWithMasterDBView/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/ValidateSDContactDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/campaigns/refreshValidateSDAccountDataWithMasterDBView/:campaignId',
          name: 'compare-account-data-to-master-data',
          component: () => import('@/views/RefreshValidateSDAccountDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/campaigns/refreshValidateClientViewAccountDataWithMasterDBView/:campaignId',
          name: 'compare-account-data-to-master-data',
          component: () => import('@/views/RefreshValidateClientViewAccountDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
           {
          path: '/campaigns/refreshValidateSDContactDataWithMasterDBView/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/RefreshValidateSDContactDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/campaigns/refreshValidateClientViewContactDataWithMasterDBView/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/RefreshValidateClientViewContactDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
         {
          path: '/contacts/refreshValidateSDContactDataWithMasterDBView/:campaignId',
          name: 'compare-contact-data-to-master-data',
          component: () => import('@/views/RefreshValidateSDContactDataWithMasterDBView.vue'),
          meta: {
            rule: 'admin',
            authRequired : true,
            resource: 'import-account-contact-to-campaign',
            action: 'read'
          }
        },
        
        // {
        //   path: '/apps/user/user-list',
        //   name: 'app-user-list',
        //   component: () => import('@/views/apps/user/user-list/UserList.vue'),
        //   meta: {
        //     breadcrumb: [{
        //         title: 'Home',
        //         url: '/'
        //       },
        //       {
        //         title: 'User'
        //       },
        //       {
        //         title: 'List',
        //         active: true
        //       },
        //     ],
        //     pageTitle: 'User List',
        //     rule: 'editor'
        //   },
        // },
        {
          path: '/apps/user/user-view/:userId',
          name: 'app-user-view',
          component: () => import('@/views/apps/user/UserView.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/'
              },
              {
                title: 'User'
              },
              {
                title: 'View',
                active: true
              },
            ],
            pageTitle: 'User View',
            rule: 'editor'
          },
        },
        {
          path: '/apps/user/user-edit/:userId',
          name: 'app-user-edit',
          component: () => import('@/views/apps/user/user-edit/UserEdit.vue'),
          meta: {
            breadcrumb: [{
                title: 'Home',
                url: '/'
              },
              {
                title: 'User'
              },
              {
                title: 'Edit',
                active: true
              },
            ],
            pageTitle: 'User Edit',
            rule: 'editor'
          },
        }

      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'public',
            resource: 'login'
          }
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'public',
            resource: 'error-404'
          }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
              rule: 'public',
              resource: 'forgot-password'
          }
      },
      {
          path: '/reset-password/:token',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
              rule: 'public',
              resource: 'reset-password'

          }
      },
      {
          path: '/unauthorized',
          name: 'unauthorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'public',
            resource: 'unauthorized'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    },
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})



router.beforeEach((to, from, next) => {
  // auth.login({ target: to.path });
  // If auth required, check login. If login fails redirect to login page
  if (to.meta.authRequired) {
      let isAuthenticated = false
      if (localStorage.getItem("userInfo") === null && localStorage.getItem("accessToken") === null) {
          router.push({
            path: '/login'
          }).catch(err => {console.log(err)})
      }else{
        isAuthenticated = true
      }
  }

  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  let accessToken = localStorage.getItem("accessToken");
  if(userInfo != null || accessToken != null){
    if(userInfo.status == 'Suspended'){
         // If JWT login
           localStorage.removeItem("accessToken");
           localStorage.removeItem("userInfo");
           router.push("/login").catch(() => {});
           location.reload();
    }


   if(to.name != 'forgot-password' && to.name != 'page-error-404' && to.name != 'reset-password' && to.name != 'unauthorized'){
    defineAbilitiesFor().then(function(data){
      const abilities = data
      const canNavigate = to.matched.some(route => {
      if(route.meta.action !== undefined){
        if(!abilities.can(route.meta.action,route.meta.resource)){
          router.push({
          path: '/unauthorized'
          })
        }
      }
      })

}); 

   }



  }


  
 
  return next()

});

export default router
